import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Linkedin, Github } from 'lucide-react';

const Footer = () => {
  const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Services', href: '/services' },
    { name: 'About', href: '/about' },
    { name: 'Portfolio', href: '/portfolio' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact', href: '/contact' },
    { name: 'Terms', href: '/terms' },
  ];

  const services = [
    { name: 'Medical Device Consulting', href: '/services#medical-devices' },
    { name: 'Software Development', href: '/services#software' },
    { name: 'AI Integration', href: '/services#ai' },
    { name: 'Regulatory Compliance', href: '/services#compliance' },
  ];

  return (
    <footer className="bg-[#111827] border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Column 1: Logo & Description */}
          <div>
            <Link to="/">
              <img
                src="/images/p2p-logo.png"
                alt="P2P Digital"
                width={500}
                height={500}
                className="h-8 w-8 object-contain object-left"
              />
            </Link>
            <p className="mt-4 text-slate-400 text-sm leading-relaxed">
              Transforming ideas into innovative medical device, software, and AI solutions.
            </p>
          </div>

          {/* Column 2: Navigation */}
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
              Navigation
            </h3>
            <ul className="space-y-3">
              {navigation.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-slate-400 hover:text-cyan-400 transition text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Services */}
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
              Services
            </h3>
            <ul className="space-y-3">
              {services.map((item) => (
                <li key={item.name}>
                  <Link
                    to={item.href}
                    className="text-slate-400 hover:text-cyan-400 transition text-sm"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 4: Contact */}
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 mb-4">
              Contact
            </h3>
            <div className="space-y-3 text-sm">
              <p className="text-slate-400">Perth, Australia</p>
              <a
                href="mailto:contact@p2pdigital.com.au"
                className="text-cyan-400 block"
              >
                contact@p2pdigital.com.au
              </a>
            </div>
            <div className="flex items-center space-x-4 mt-6">
              <a
                href="mailto:contact@p2pdigital.com.au"
                className="text-slate-400 hover:text-white transition"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white transition"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white transition"
                aria-label="GitHub"
              >
                <Github className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/[0.06]">
          <p className="text-center text-slate-500 text-sm">
            &copy; {new Date().getFullYear()} P2P Digital Pty Ltd. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
